import { TKV2_ORDER_ATTACHMENT_API } from '@aloft/toolkit-shared';
import { UseQueryOptions, UseQueryResult, useQuery } from '@tanstack/react-query';

import { z } from 'zod';

import {
  GetMarketAdjustmentsError,
  GetMarketAdjustmentsVariables,
  fetchGetMarketAdjustments,
} from '../toolkitComponents.ts';
import { queryKeyFn, useToolkitContext } from '../toolkitContext.ts';

const API_SCHEMA = TKV2_ORDER_ATTACHMENT_API.MARKET_ADJUSTMENTS.GET;

export const useGetMarketAdjustments = (
  variables: GetMarketAdjustmentsVariables,
  opts?: Omit<
    UseQueryOptions<z.infer<typeof API_SCHEMA.RESPONSE>, GetMarketAdjustmentsError>,
    'queryKey' | 'queryFn'
  >,
): UseQueryResult<z.infer<typeof API_SCHEMA.RESPONSE>, GetMarketAdjustmentsError> => {
  const { fetcherOptions } = useToolkitContext();

  return useQuery<z.infer<typeof API_SCHEMA.RESPONSE>, GetMarketAdjustmentsError>({
    queryKey: queryKeyFn({
      path: '/api/v2/orders/{orderID}/attachments/marketAdjustments',
      operationId: 'getMarketAdjustments',
      variables,
    }),
    queryFn: async () => {
      const res = await fetchGetMarketAdjustments({ ...fetcherOptions, ...variables });
      return API_SCHEMA.RESPONSE.parse(res);
    },
    ...opts,
  });
};
